import Environment from "./environment.type";

export const environment: Environment = {
    tenantSlug: 'foerster',
    sentryEnvironment: 'production',
};
